import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=cde3271e&"
import script from "./delete.vue?vue&type=script&lang=js&"
export * from "./delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde3271e')) {
      api.createRecord('cde3271e', component.options)
    } else {
      api.reload('cde3271e', component.options)
    }
    module.hot.accept("./delete.vue?vue&type=template&id=cde3271e&", function () {
      api.rerender('cde3271e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/GruposWorkers/delete.vue"
export default component.exports